<template>
  <Form as="div" ref="form">
    <div>
      <div class="container">
        <header class="header-static">
          <a href="/#memberInfo" class="open-modal close-button"><span class="icon-cross" /></a>
        </header>
      </div>

      <div class="container row" data-test-component="permission">
        <div class="small-12 medium-6 columns">
          <div v-cloak>
            <div>
              <h1 v-html="viewModel.Content.Title" />
              <p v-html="viewModel.Content.Description" />
            </div>

            <div v-cloak>
              <h2 v-html="viewModel.Content.ContactInformationTitle" />
              <div class="row medium-unstack">
                <div class="columns">
                  <LabelAndTooltip
                    for="Email"
                    :label="viewModel.Content.EmailLabel"
                    :tooltip="viewModel.Content.EmailTooltip"
                  />
                </div>
                <div class="columns">
                  <Field
                    name="Email"
                    :rules="'required|email'"
                    label="Email"
                    :model-value="viewModel.Data.ContactInformation.Email"
                  >
                    <input
                      type="email"
                      name="Email"
                      :placeholder="viewModel.Content.EmailaddressPlaceholder"
                      v-model="viewModel.Data.ContactInformation.Email"
                    />
                  </Field>
                  <ValidationError name="Email" />
                </div>
              </div>
              <div class="row medium-unstack">
                <div class="columns">
                  <LabelAndTooltip
                    for="Telefon"
                    :label="viewModel.Content.PhoneNumberLabel"
                    :tooltip="viewModel.Content.PhoneNumberTooltip"
                  />
                </div>
                <div class="columns">
                  <Field
                    name="Telefon"
                    label="Telefon"
                    :rules="'numeric|min:8'"
                    :model-value="viewModel.Data.ContactInformation.Phonenumber"
                  >
                    <input
                      type="tel"
                      name="Telefon"
                      :placeholder="viewModel.Content.PhonenumberPlaceholder"
                      maxlength="8"
                      v-model="viewModel.Data.ContactInformation.Phonenumber"
                    />
                  </Field>
                  <ValidationError name="Telefon" />
                </div>
              </div>
            </div>
            <template v-if="viewModel.Content.PermissionGiven">
              <h2 v-html="viewModel.Content.OptionsTitle" />

              <div
                class="checkbox-inline"
                v-for="(option, index) in viewModel.Data.Options"
                :key="'opt' + option.Id"
              >
                <p v-if="index === 1">{{ viewModel.Content.OptionsSubTitle }}</p>
                <input :id="'receive-' + index" type="checkbox" v-model="option.PermissionGiven" />
                <label :for="'receive-' + index">
                  {{ option.Name }}
                </label>
              </div>

              <div>
                <a @click="removeChecked()"> {{ viewModel.Content.RemoveAllSelections }} </a>
              </div>
            </template>
            <template v-else>
              <div class="checkbox-inline">
                <input
                  id="marketing__subscribe"
                  type="checkbox"
                  v-model="viewModel.Data.AcceptAllOptions"
                />
                <label for="marketing__subscribe">
                  {{ viewModel.Content.RecieveMarketingMaterialLabel }}
                </label>
              </div>
            </template>
          </div>
          <div>
            <div>
              <small> {{ viewModel.Content.Disclaimer }} </small>
            </div>
            <template v-if="viewModel.Content.ServicesLinkModel != null">
              <div>
                <small>
                  <a :href="viewModel.Content.ServicesLinkModel.Url" target="_blank">
                    {{ viewModel.Content.ServicesLinkModel.Text }}
                  </a>
                </small>
              </div>
            </template>
            <template v-if="viewModel.Content.PartnersLinkModel != null">
              <div>
                <small>
                  <a :href="viewModel.Content.PartnersLinkModel.Url" target="_blank">
                    {{ viewModel.Content.PartnersLinkModel.Text }}
                  </a>
                </small>
              </div>
            </template>
            <template
              v-if="
                !viewModel.Content.PermissionGiven &&
                viewModel.Content.PersonalDataLinkModel != null
              "
            >
              test
              <div>
                <small>
                  <a :href="viewModel.Content.PersonalDataLinkModel.Url" target="_blank">
                    {{ viewModel.Content.PersonalDataLinkModel.Text }}
                  </a>
                </small>
              </div>
            </template>

            <div class="row medium-unstack push-up">
              <div class="columns">
                <a class="button" :class="{ disabled: disableSaveButton }" @click="saveChanges()">
                  {{ viewModel.Content.SaveLabel }}
                </a>
              </div>
              <div class="columns" />
            </div>
          </div>
        </div>
        <!--
    <div class="small-12 medium-6 columns">
        <div class="row policy-basket">
            <div class="small-12 medium-12 large-10 large-offset-2 columns">
                <div class="callout">
                    <h2>{{ viewModel.DataPolicyTitle }}</h2>
                    <p>{{ viewModel.DataPolicyDescription }}</p>

                    @if (viewModel.Content.DataPolicyButtonLinkModel != null)
                    {
                        <a href=":viewModel.Url" class="button secondary small-12 medium-10 large-8">{{ viewModel.Text }}</a>
                    }
                </div>
            </div>
        </div>
    </div>

                    -->
      </div>

      <div v-cloak>
        <!-- Opt-In -->
        <transition name="modal">
          <v-modal
            :is-open="showOptInModal"
            @close="
              showOptInModal = false;
              modalClose();
            "
          >
            <template #title>
              <h3 v-html="viewModel.Content.ConfirmOptInTitle" />
            </template>

            <template #content>
              <div>
                <p v-html="viewModel.Content.ConfirmOptInDescription" />
              </div>
            </template>

            <template #footer>
              <div>
                <button
                  class="button"
                  @click="
                    showOptInModal = false;
                    modalClose();
                  "
                >
                  OK
                </button>
              </div>
            </template>
          </v-modal>
        </transition>

        <!-- Opt-Out -->
        <transition name="modal">
          <v-modal
            :is-open="showOptOutModal"
            @close="
              showOptOutModal = false;
              modalClose();
            "
          >
            <template #title>
              <h3 v-html="viewModel.Content.ConfirmOptOutTitle" />
            </template>

            <template #content>
              <div>
                <p v-html="viewModel.Content.ConfirmOptOutDescription" />
              </div>
            </template>

            <template #footer>
              <div>
                <button
                  class="button"
                  @click="
                    showOptOutModal = false;
                    modalClose();
                  "
                >
                  OK
                </button>
              </div>
            </template>
          </v-modal>
        </transition>
      </div>
    </div>
  </Form>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';
import axios from 'axios';
import ValidationError from '@/components/UI/ValidationError.vue';
import LabelAndTooltip from '@/components/UI/LabelAndTooltip.vue';

export default {
  name: 'Permissions',
  components: { ValidationError, LabelAndTooltip },
  props: {
    modelValue: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    console.log(this.modelValue);
    return {
      clone: null,
      config: {
        headers: {
          'Content-Type': 'application/json'
        }
      },
      showOptInModal: false,
      showOptOutModal: false,
      subscriptionChanged: false,
      viewModel: this.modelValue
    };
  },
  computed: {
    disableSaveButton() {
      return this.viewModel.Data.InitialPermissionGiven && this.subscriptionChanged
        ? false
        : !this.viewModel.Data.InitialPermissionGiven && this.viewModel.Data.AcceptAllOptions
          ? false
          : true;
    },
    optedIn() {
      const result = this.viewModel.Data.Options.filter(
        (option) => option.PermissionGiven === true
      );
      return result.length > 0 ? true : false;
    }
  },
  watch: {
    'viewModel.Data.AcceptAllOptions': function (val) {
      if (val !== this.clone.InitialPermissionGiven) {
        this.subscriptionChanged = true;
        this.viewModel.Data.Options.forEach((option) => {
          option.PermissionGiven = true;
        });
      } else {
        this.subscriptionChanged = false;
      }
    },
    'viewModel.Data.Options': {
      handler(val) {
        const result = Object.keys(val).filter(
          (option) => val[option] !== this.clone.Options[option]
        );
        this.subscriptionChanged = result.length ? true : false;
      },
      deep: true
    },
    'viewModel.Data.ContactInformation': {
      handler(val) {
        if (
          val.Email !== this.clone.ContactInformation.Email ||
          val.Phonenumber !== this.clone.ContactInformation.Phonenumber
        ) {
          this.subscriptionChanged = true;
        } else {
          this.subscriptionChanged = false;
        }
      },
      deep: true
    }
  },
  created() {
    this.clone = JSON.parse(JSON.stringify(this.viewModel.Data));
  },
  methods: {
    removeChecked() {
      this.viewModel.Data.Options.forEach((option) => {
        option.PermissionGiven = false;
      });
    },
    update() {
      axios
        .post(Utility.constants().API.marketing_permission_save, this.viewModel.Data, this.config)
        .then(() => {})
        .catch(() => {}); // TODO: Why then and catch without content?
    },
    saveChanges() {
      if (Object.keys(this.$refs.form.getErrors()).length != 0) {
        window.Utility.scrollToElem($('.error-msg:visible').first().parent().parent());
        return;
      }

      if (this.subscriptionChanged && this.optedIn) {
        this.showOptInModal = true;
      } else if (this.subscriptionChanged && !this.optedIn) {
        this.showOptOutModal = true;
      }

      this.update();
    },
    modalClose() {
      window.location.pathname = '/';
    }
  }
};
</script>
